import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  @media (max-width: 1024px) {
    width: auto;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  margin: 25px 0 0;
`;

export const SubTitle = styled.p`
  font-size: 16px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 16px;
`;

export const MainInfoContent = styled.div`
  background: #ffffffcc;
  border-top: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0px 20px 25px -5px #0000001a;
  padding: 33px;
`;

export const OffersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 680px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const OfferCard = styled.div`
  background: linear-gradient(107.35deg, #296bcd 0%, #245499 43.88%);
  border-radius: 5px;
  padding: 4px 8px 4px;
  color: white;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 9.25px 18.5px -4.44px #00000040;
  transition: transform 0.2s cubic-bezier(0.2, 0, 0.2, 1);
  z-index: 1;
  transform: scale(1);
  backface-visibility: hidden;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  transform: translateZ(0);
  transform-origin: center center;
  filter: blur(0);
  min-height: 180px;
  -webkit-filter: blur(0);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #00d3f3 0%, #2b7fff 100%);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    width: 100%;
    background: white;
    pointer-events: none;
  }
  &:hover {
    transform: scale(1.02) translateZ(0);
    filter: brightness(1.02);
    z-index: 10;
  }

  ${(props) =>
    props.isActive &&
    `
    transform: scale(1.02);
    z-index: 5;
    border: 2px solid #FDC700;
  `}
`;

export const BadgeIcon = styled.img`
  position: absolute;
  top: 5px;
  left: 1px;
  z-index: 2;
  width: 15px;
`;

export const CardHeader = styled.h3`
  font-weight: 900;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-top: 32px;
  margin-bottom: 19px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
`;

export const PriceBox = styled.div`
  position: relative;
  border-radius: 6.58px;
  padding: 7.77px;
  text-align: left;
  margin-bottom: 8px;
  border: 1px solid #ffffff33;
  overflow: hidden;
  outline: none;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.1);
    z-index: 0;
    border: none;
  }

  * {
    position: relative;
    z-index: 1;
  }
`;

export const PriceTitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #53eafd;
  margin-bottom: 3px;
  letter-spacing: 0.11px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  &.discount-label {
    color: #ffd700;
    margin-top: 8px;
  }
`;

export const PriceValue = styled.div`
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  display: flex;
  color: #ffffff;
  letter-spacing: 0;
  backface-visibility: hidden;
  perspective: 1000px;
  font-variant-numeric: tabular-nums;
  align-items: baseline;
  display: inline-flex;
  transform: translateZ(0) scale(1);
  will-change: contents;

  &.discount-price {
    color: #ffd700;
  }

  span {
    font-size: 12px;
    margin-left: 2.96px;
    color: #53eafd;
    font-weight: 700;
    display: inline-block;
  }

  &.discount-price span {
    color: #ffd700;
  }
`;

export const UnitsInfo = styled.p`
  font-size: 13px;
  margin-top: 3px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  color: #ffffff;
  font-weight: 600;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;

export const ValidityBox = styled.div`
  font-size: 11px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 2px;
  color: #ffffff99;
  margin-top: 8px;
  font-weight: 500;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  span {
    color: #ffffff;
    font-weight: 600;
  }

  .calendar-icon {
    width: 12px;
  }
`;

export const FooterText = styled.p`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 3px;
  color: #ffffff66;
  font-weight: 400;
  margin-top: 38px;
  margin-bottom: 4px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;
export const StarImg = styled.img`
  width: 11px;
  margin-right: 2px;
`;
export const DateImg = styled.img``;
export const LevinImg = styled.img`
  width: 14px;
`;

export const OffersGridBig = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;
export const OfferCardBig = styled.div`
  display: flex;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  position: relative;
  margin-top: 25px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.2, 0, 0.2, 1);
  z-index: 1;
  transform: scale(1);
  backface-visibility: hidden;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  transform: translateZ(0);
  transform-origin: center center;
  filter: blur(0);
  -webkit-filter: blur(0);

  .offer-flex {
    flex: 0.7;
    width: 180px;
    border-radius: 0;
    box-shadow: none;
    transition: none;

    &:hover,
    &:focus,
    &.active {
      transform: none !important;
      outline: none !important;
      box-shadow: none !important;
      z-index: 1 !important;
    }
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    z-index: 10;
    background: linear-gradient(90deg, #00d3f3 0%, #2b7fff 50%, #9810fa 100%);
  }
  .card-header {
    font-size: 14px;
  }
  .units-info {
    font-size: 11px;
  }
  .validity-box {
    font-size: 9px;
  }
  .premium-offer {
    font-size: 13px;
  }
  .offer-flex {
    flex: 0.7;
  }
  &:hover {
    transform: scale(1.02) translateZ(0);
    z-index: 10;
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.15);
  }
  ${(props) =>
    props.isActive &&
    `
    transform: scale(1.03);
    z-index: 5;
    outline-offset: -2px;
    border: 2px solid #FDC700;

    .offer-flex {
      transform: none !important;
    }
  `}
  @media (max-width: 680px) {
    flex-direction: column;
    .offer-flex {
      flex: auto;
      width: 100%;
    }
  }
`;
export const InfoSide = styled.section`
  padding: 12px 6.6px 6.6px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 180px;
`;

export const InfoHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: 15px;
  color: #212529;
  margin-bottom: 4px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;

export const InfoDescription = styled.article`
  font-size: 12px;
  color: #6c757d;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.5;
`;

export const TagGroup = styled.nav`
  display: flex;
  gap: 8px;
  margin-top: 0;
`;

export const FeatureTag = styled.span`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 0.55px solid #e2e8f0;
  padding: 4px 6px;
  border-radius: 3.85px;
  font-size: 11px;
  color: #212529;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 3px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;
export const FeatureTagImg = styled.div`
  width: 11px;
  height: 11px;
  background: linear-gradient(135deg, #00d3f3 0%, #2b7fff 100%);
  box-shadow:
    0px 1.1px 1.65px -1.1px #0000001a,
    0px 2.75px 4.12px -0.82px #0000001a;
  border-radius: 3.85px;
  display: flex;
  align-items: center;
  justify-content: center;
  .wifi-img {
    width: auto;
  }
`;

export const ProductBadge = styled.footer`
  background: #eff6ff;
  border: 0.27px solid #bedbff;
  font-weight: 500;
  font-size: 11px;
  color: #6c757d;
  padding: 4px;
  border-radius: 8px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  strong {
    font-weight: 700;
    color: #212529;
    display: block;
    font-size: 13px;
  }
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
`;

export const OfferImageWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OfferImageBig = styled.div`
  width: 100%;
  max-width: 90px;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
  margin-top: auto;
  align-self: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

export const ErrorMessage = styled.div`
  color: #e45270;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
  font-weight: 500;
`;
